import { Component, OnInit } from '@angular/core';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { IMessagingSender } from 'src/app/models/IMessaging';
import { MatTableDataSource, MatTabChangeEvent } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message-home',
  templateUrl: './message-home.component.html',
  styleUrls: ['./message-home.component.css']
})
export class MessageHomeComponent implements OnInit {

  //dataSource = ELEMENT_DATA;
  displayedColumns = ['id', 'Patient', 'AsssignedTo', 'PracticeProvider', 'Urgency', 'Phone', 'Pharmacy', 'date', 'priority'];

  //dataSource1 = ELEMENT_DATA1;
  displayedColumns1 = ['id', 'SentFrom', 'Subject', 'Message', 'Date', 'priority'];

  Messagesdata: any[] = [];
  dataSource1 = new MatTableDataSource(this.Messagesdata);

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private messageService: MessagesService, private router: Router) { }

  ngOnInit() {
    this.router.navigateByUrl('/viewmessage/' + '13');
    this.loadMessages();


  }
  messages: IMessagingSender[] = [];

  loadMessages() {
    this.messageService.getAllMessages(sessionStorage.getItem("userId"), Number(sessionStorage.getItem("LocationId"))).subscribe(data => {
      this.messages = data;
      this.dataSource1.data = this.messages;
    },
      (err: any) => console.log(err)
    );
  }

  onLinkClick(event: MatTabChangeEvent) {
    event.tab.isActive = true;
    var catid = this.getPlanCategoryId(event.tab.textLabel);
    this.router.navigateByUrl('/viewmessage/' + catid);
  }

  getPlanCategoryId(name) {
    var catId = '';
    switch (name) {
      case 'Amendment':
        catId = '13';
        break;
      case 'Deleted':
        catId = '12';
        break;
      case 'Follow Ups ':
        catId = '3';
        break;
      case 'Lab Results':
        catId = '14';
        break;
      case 'Letters':
        catId = '7';
        break;
      case 'Orders ':
        catId = '2';
        break;
      case 'Rx':
        catId = '1';
        break;
      case 'Sent':
        catId = '11';
        break;
      case 'Staff':
        catId = '4';
        break;
      case 'Transcriptions ':
        catId = '6';
        break;
      case 'Unsigned Charts':
        catId = '10';
        break;
      default:
        catId = '13';

    }
    return catId;
  }

}
